import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import Button from "../../components/ergo-elements/components/Button";
import CalendarIcon from "../../components/ergo-elements/components/Icons/CalendarIcon";
import PrinterIcon from "../../components/ergo-elements/components/Icons/PrinterIcon";
import I18n from "../../i18n";
import { FlexEnd } from "../../components/Flex/";
import { HistoryButton } from "../Admissions/API";
import queryString from "query-string";
import { HospitalName } from "./HospitalName";
import { fontMedium } from "../../constants";

import { getCurrentLanguage } from "../../LanguageHelper";

const areButtonsVisible = (path) => !path.includes("login");

const buttonStyle = {
  fontSize: fontMedium,
  lineHeight: "21px",
  fontWeight: 300,
  padding: "0.85rem 1.5rem 0.85rem 3.125rem",
};

export const BottomMenu = ({ placeName, siteName }) => {
  const location = useLocation();
  const queryObjectValue = location.pathname.includes("admissions-patient")
    ? null
    : queryString.parse(location.search);
  const { pathname } = useLocation();
  const { lang } = useParams();
  return (
    <div style={{ justifySelf: "end", height: 85, alignItems: "center" }}>
      {areButtonsVisible(pathname) ? (
        <FlexEnd>
          <HospitalName placeName={placeName} siteName={siteName} />
          <HistoryButton
            queryObject={queryObjectValue}
            style={{ marginRight: "20px", height: "100%" }}
          >
            <Button
              variant="secondary"
              iconLeft={CalendarIcon}
              style={buttonStyle}
            >
              <I18n keys="All admissions" />
            </Button>
          </HistoryButton>
          <Link to={`/${getCurrentLanguage({ params: {lang} })}/blank-forms`}>
            <Button
              variant="secondary"
              iconLeft={PrinterIcon}
              style={buttonStyle}
            >
              <I18n keys="Print blank forms" />
            </Button>
          </Link>
        </FlexEnd>
      ) : null}
    </div>
  );
};
